/**
 * Pure utils and constants for the Categories form.
 * No React dependencies – safe to reuse and test in isolation.
 * @typedef {import('../../../models/ProductCategory').ProductCategory} ProductCategory
 */

import { CATEGORIES_QUERY_KEY as CK } from '../../common/utils/queryKeys';

/** Query key for product categories list (use with useQuery / invalidateQueries) */
export const CATEGORIES_QUERY_KEY = CK;

export const emptyFormData = () => ({
  category_name: '',
  sub_category_name: '',
  mlb_category_id: '',
  mlb_category_child_id: '',
  mlbCategoryDisplayName: '',
  mlbCategoryChildDisplayName: ''
});

/**
 * Map API category row to form fields (editable + MLB link fields).
 * Display names for MLB are set from ids when loading (no API names stored in product_categories).
 * @param {ProductCategory} row
 */
export const categoryToFormData = (row) => ({
  category_name: row?.category_name ?? '',
  sub_category_name: row?.sub_category_name ?? '',
  mlb_category_id: row?.mlb_category_id ?? '',
  mlb_category_child_id: row?.mlb_category_child_id ?? '',
  mlbCategoryDisplayName: row?.mlb_category_id ? String(row.mlb_category_id) : '',
  mlbCategoryChildDisplayName: row?.mlb_category_child_id ? String(row.mlb_category_child_id) : ''
});
